

















import IsLoading from "@/components/element/IsLoading.vue";
import { DocumentType, FinanceType, LoadingStatusType, TransactionType } from "@/enums/enums";
import Layout from "@/views/Layout.vue";
import { Component, Vue, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";
import router from "./router";

const StoreAuthentication = namespace("Authentication");
const StoreMerchant = namespace("Merchant");
@Component({ components: { Layout, IsLoading } })
export default class extends Vue {
  private transactionType: TransactionType | DocumentType = TransactionType.None;
  private financeType: FinanceType = FinanceType.None;
  private transactionId: number = 0;
  private merchantId: number = 0;
  private headerTypeCode = "";
  private passCode = "";
  private useLayoutPage = false;
  private sourceType: number = 0;
  private pndItem: number = 0;
  private customizeId: string = "";

  @StoreMerchant.Getter
  private getMerchantDetailLoadingStatus!: LoadingStatusType;
  @StoreAuthentication.Getter
  private getLoginLoadingStatus!: LoadingStatusType;

  @StoreMerchant.Action
  private DoGetMerchantDetail!: () => void;
  @StoreAuthentication.Action
  private DoGetUserInfo!: (merchantId: number) => void;

  get merchantDetailLoadingStatus() {
    return this.getMerchantDetailLoadingStatus === LoadingStatusType.Success;
  }

  get loginLoadingStatus() {
    return this.getLoginLoadingStatus === LoadingStatusType.Success;
  }
  get isRouteQueryChanged() {
    if (this.transactionType > TransactionType.None && this.transactionId > 0 && this.merchantId > 0) {
      if (this.transactionType == TransactionType.DailyJournal) {
        return true;
      } else if (this.transactionType == TransactionType.WithholdingTax) {
        return true;
      } else if (this.transactionType == TransactionType.PP30) {
        return true;
      } else if (this.transactionType == TransactionType.Pnd1) {
        return true;
      } else if (this.transactionType == TransactionType.Pnd2) {
        return true;
      } else if (this.transactionType == TransactionType.Pnd3) {
        return true;
      } else if (this.transactionType == TransactionType.Pnd53) {
        return true;
      } else if (this.transactionType == DocumentType.Envelope) {
        return true;
      } else if (this.transactionType == DocumentType.ExecutiveSummary) {
        return true;
      } else {
        if (this.financeType > FinanceType.None) {
          return true;
        }
      }
    }
    return false;
  }

  @Watch("$route.query", { immediate: true })
  routeQueryChanged(newVal: any) {
    let urlEtti: any = this.$route.query.etti;
    this.transactionType = urlEtti ? urlEtti.PeakDecryption() : TransactionType.None;
    let urlEfti: any = this.$route.query.efti;
    this.financeType = urlEfti ? urlEfti.PeakDecryption() : FinanceType.None;
    let urlEti: any = this.$route.query.eti;
    this.transactionId = urlEti ? urlEti.PeakDecryption() : 0;
    let urlEmi: any = this.$route.query.emi;
    this.merchantId = urlEmi ? urlEmi.PeakDecryption() : 0;
    let urlEsti: any = this.$route.query.esti;
    this.sourceType = urlEsti ? urlEsti.PeakDecryption() : 0;
    let urlEhi: any = this.$route.query.ehi;
    this.headerTypeCode = urlEhi ? urlEhi : "";
    let urlPassCode: any = this.$route.query.passcode;
    this.passCode = urlPassCode ? urlPassCode : "";
    let pndItem: any = this.$route.query.pndItem;
    this.pndItem = pndItem && pndItem.ToNumber() > 0 ? pndItem.ToNumber() : 0;
    let urlEcmi: any = this.$route.query.ecmi;
    this.customizeId = urlEcmi ? urlEcmi.PeakDecryptionToString() : "";
  }
  @Watch("merchantId")
  merchantIdChanged() {
    if (this.merchantId > 0) {
      this.DoGetUserInfo(this.merchantId);
      this.DoGetMerchantDetail();
    }
  }
  @Watch("$route", { immediate: true })
  routeChanged(newVal: any) {
    if (newVal.name) {
      this.SetUseLayoutPage(newVal.name);
    }
  }
  public SetUseLayoutPage(routerName: string) {
    switch (routerName) {
      case "sessionExpire":
      case "pageNotFound":
      case "update":
        this.useLayoutPage = false;
        break;
      default:
        if (this.isRouteQueryChanged) {
          let query = Object.assign({}, this.$route.query);
          if (this.$route.name == "Home") {
            this.DoReplaceURL(query);
          }
          this.useLayoutPage = true;
        } else {
          this.useLayoutPage = false;
          router.push({ name: "pageNotFound" });
        }
        break;
    }
  }

  public DoReplaceURL(query: any) {
    let urlName = "";
    switch (this.transactionType) {
      case TransactionType.Quotation: {
        if (this.financeType === FinanceType.InFlow) {
          urlName = "quotation";
        } else if (this.financeType === FinanceType.OutFlow) {
          urlName = "purchaseOrder";
        }
        break;
      }
      case TransactionType.Invoice: {
        if (this.financeType === FinanceType.InFlow) {
          urlName = "invoice";
        } else if (this.financeType === FinanceType.OutFlow) {
          urlName = "expenses";
        }
        break;
      }
      case TransactionType.Receipt: {
        if (this.financeType === FinanceType.InFlow) {
          urlName = "receipt";
        }
        break;
      }
      case TransactionType.TaxInvoice: {
        if (this.financeType === FinanceType.InFlow) {
          urlName = "taxInvoice";
        }
        break;
      }
      case TransactionType.DailyJournal: {
        urlName = "dailyJournal";

        break;
      }
      case TransactionType.BillingNote: {
        if (this.financeType === FinanceType.InFlow) {
          urlName = "billingNote";
        } else {
          urlName = "combinePaymentNote";
        }
        break;
      }
      case TransactionType.WithholdingTax: {
        urlName = "withholdingTax";

        break;
      }
      case TransactionType.PP30: {
        if (this.financeType > FinanceType.None) {
          if (this.financeType === FinanceType.InFlow) {
            urlName = "salesTaxInvoiceItem";
          } else {
            urlName = "purchasesTaxInvoiceItem";
          }
        } else {
          urlName = "pp30";
        }
        break;
      }
      case TransactionType.Pnd1: {
        if (this.pndItem > 0) {
          urlName = "pnd1Item";
        } else {
          urlName = "pnd1";
        }
        break;
      }
      case TransactionType.Pnd2: {
        if (this.pndItem > 0) {
          urlName = "pnd2Item";
        } else {
          urlName = "pnd2";
        }
        break;
      }
      case TransactionType.Pnd3: {
        if (this.pndItem > 0) {
          urlName = "pnd3Item";
        } else {
          urlName = "pnd3";
        }
        break;
      }
      case TransactionType.Pnd53: {
        if (this.pndItem > 0) {
          urlName = "pnd53Item";
        } else {
          urlName = "pnd53";
        }
        break;
      }
      case TransactionType.CreditNote: {
        if (this.financeType === FinanceType.InFlow) {
          urlName = "creditNote";
        } else if (this.financeType === FinanceType.OutFlow) {
          urlName = "creditNoteExpense";
        }
        break;
      }
      case TransactionType.DebitNote: {
        if (this.financeType === FinanceType.InFlow) {
          urlName = "debitNote";
        } else if (this.financeType === FinanceType.OutFlow) {
          urlName = "debitNoteExpense";
        }
        break;
      }
    }
    this.$router.replace({ name: urlName, query: query }).catch((err) => {});
  }
}
